import { useContext } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

function SvgComponent(props: any) {
  const {
    info: { theme },
  } = useContext(AppInfoContext);

  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.9565 7.36106L67.1683 3.3459C68.0987 2.17852 67.8358 0.477182 66.6058 -0.37087C59.6357 -5.1765 51.2673 -7.79395 42.7518 -7.79395C34.2362 -7.79395 25.8678 -5.1765 18.903 -0.37087C17.6729 0.477182 17.4049 2.17852 18.3405 3.3459L21.5522 7.36106C22.388 8.40281 23.8914 8.64361 24.9953 7.89502C30.2307 4.33006 36.323 2.45597 42.7518 2.45597C49.1805 2.45597 55.2728 4.33006 60.5083 7.89502C61.6121 8.64885 63.1155 8.40281 63.9513 7.36106H63.9565Z"
        fill="#E7F6F5"
        fill-opacity="0.05"
      />
      <path
        d="M42.7518 75.5921C50.5787 75.5921 58.1113 73.4615 64.703 69.4097C65.9698 68.6297 66.3167 66.9493 65.4546 65.7401L62.4637 61.5522C61.6857 60.4633 60.1929 60.1492 59.0417 60.8402C54.1374 63.7927 48.555 65.3422 42.7518 65.3422C36.9486 65.3422 31.3662 63.7927 26.4671 60.8402C25.3159 60.1492 23.8231 60.4581 23.0451 61.5522L20.0541 65.7401C19.1921 66.9493 19.5337 68.6297 20.8058 69.4097C27.3975 73.4615 34.9301 75.5921 42.757 75.5921H42.7518Z"
        fill="#E7F6F5"
        fill-opacity="0.05"
      />
      <path
        d="M12.0767 58.2123L16.1085 55.0137C17.1545 54.1814 17.3963 52.6842 16.6446 51.5849C13.065 46.3709 11.1831 40.3037 11.1831 33.9014C11.1831 28.1273 12.7391 22.5627 15.7037 17.6785C16.3976 16.5321 16.0874 15.0453 14.9888 14.2706L10.7836 11.2919C9.56937 10.4334 7.88204 10.7789 7.09881 12.0405C3.03027 18.6051 0.890873 26.1067 0.890873 33.9014C0.890873 42.382 3.51913 50.7159 8.34461 57.6521C9.19616 58.8771 10.9045 59.1441 12.0767 58.2123Z"
        fill="#E7F6F5"
        fill-opacity="0.05"
      />
      <path
        d="M42.7426 54.7983C31.1534 54.7983 21.7586 45.4421 21.7586 33.9006C21.7586 22.3591 31.1534 13.0029 42.7426 13.0029C54.3317 13.0029 63.7266 22.3591 63.7266 33.9006C63.7266 45.4421 54.3317 54.7983 42.7426 54.7983Z"
        fill="#E7F6F5"
        fill-opacity="0.05"
      />
    </svg>
  );
}


export default SvgComponent;
